namespace GeniuzPOS.Inventory {
    export interface IcStockSetAssembleForm {
        SysDocNo: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        RefDocNo1: Serenity.StringEditor;
        RefDocNo2: Serenity.StringEditor;
        WhsSet: Serenity.LookupEditor;
        WhsItem: Serenity.LookupEditor;
        SetItemCode: Serenity.LookupEditor;
        CallSetItemFg: Serenity.IntegerEditor;
        SetQty: Serenity.DecimalEditor;
        CalDtQtyFg: Serenity.IntegerEditor;
        ApproveFg: Serenity.IntegerEditor;
        Remark: Serenity.StringEditor;
        PostFg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
        IcStockSetAssembleDtList: IcStockSetAssembleDtEditor;
    }

    export class IcStockSetAssembleForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockSetAssemble';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockSetAssembleForm.init)  {
                IcStockSetAssembleForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.EnumEditor;
                var w6 = IcStockSetAssembleDtEditor;

                Q.initFormType(IcStockSetAssembleForm, [
                    'SysDocNo', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'RefDocNo1', w0,
                    'RefDocNo2', w0,
                    'WhsSet', w2,
                    'WhsItem', w2,
                    'SetItemCode', w2,
                    'CallSetItemFg', w3,
                    'SetQty', w4,
                    'CalDtQtyFg', w3,
                    'ApproveFg', w3,
                    'Remark', w0,
                    'PostFg', w5,
                    'CancelFg', w5,
                    'IcStockSetAssembleDtList', w6
                ]);
            }
        }
    }
}
